import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';

const pb = new PocketBase('https://bahcarplaza.com');

function MobileExplore({ view, setView }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  // ডাটাবেস থেকে ভিডিও ফেচ করা
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const records = await pb.collection('videos_list').getFullList({ sort: '-created' });
        setVideos(records);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  // স্ক্রল ট্র্যাক করার লজিক (যাতে ভিডিও অটো-পজ হয়)
  const handleScroll = (e) => {
    const container = e.target;
    const scrollPosition = container.scrollTop;
    const videoHeight = container.clientHeight;
    // কোন ভিডিওটি স্ক্রিনে আছে তা ক্যালকুলেট করা
    const index = Math.round(scrollPosition / videoHeight);
    
    if (index !== activeIndex) {
      setActiveIndex(index);
    }
  };

  return (
    // ফিক্সড কালো ব্যাকগ্রাউন্ড
    <div style={{ backgroundColor: '#000', height: '100vh', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 40, display: 'flex', flexDirection: 'column' }}>

      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar { display: none; }
          .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        `}
      </style>

      {/* Top Header */}
      <div style={{ position: 'absolute', top: 0, width: '100%', padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 50, background: 'linear-gradient(to bottom, rgba(0,0,0,0.8), transparent)' }}>
        <button onClick={() => setView('home')} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '30px', cursor: 'pointer', padding: 0 }}>←</button>
        <h2 style={{ margin: 0, color: '#fff', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '18px' }}>BAH! CARS</h2>
        <div style={{ width: '30px' }}></div>
      </div>

      {/* Videos Container */}
      <div
        onScroll={handleScroll}
        className="hide-scrollbar"
        style={{ flex: 1, overflowY: 'scroll', scrollSnapType: 'y mandatory', WebkitOverflowScrolling: 'touch', height: '100%', scrollBehavior: 'smooth' }}
      >
        {loading ? (
          <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold' }}>Loading Shorts...</div>
        ) : videos.length > 0 ? (
          videos.map((video, index) => (
            <div
              key={video.id}
              style={{ height: '100vh', width: '100%', scrollSnapAlign: 'start', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#000' }}
            >
              
              {/* 🚨 Scroll Lock Fix: Edge Touch Catchers 🚨 */}
              {/* এই অদৃশ্য লেয়ারগুলো স্ক্রল লক হতে দেবে না */}
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '25%', zIndex: 5 }}></div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '30%', zIndex: 5 }}></div>
              <div style={{ position: 'absolute', top: '25%', bottom: '30%', left: 0, width: '15%', zIndex: 5 }}></div>
              <div style={{ position: 'absolute', top: '25%', bottom: '30%', right: 0, width: '15%', zIndex: 5 }}></div>

              {/* শুধুমাত্র Active ভিডিওটিই প্লে হবে, বাকিগুলো পজ থাকবে */}
              {activeIndex === index ? (
                <>
                  {video.platform === 'YouTube' && (
                    <iframe style={{ width: '100%', height: '100%', maxWidth: '450px', border: 'none', margin: '0 auto' }} src={`https://www.youtube.com/embed/${video.video_id}?autoplay=1&loop=1&playlist=${video.video_id}&controls=0&rel=0&modestbranding=1&playsinline=1`} allow="autoplay; encrypted-media" allowFullScreen></iframe>
                  )}
                  {video.platform === 'Instagram' && (
                    <iframe style={{ width: '100%', height: '100%', maxWidth: '450px', border: 'none', backgroundColor: '#000', margin: '0 auto' }} src={`https://www.instagram.com/p/${video.video_id}/embed`} scrolling="no" allowTransparency="true" allow="encrypted-media"></iframe>
                  )}
                  {video.platform === 'Facebook' && (
                    <iframe style={{ width: '100%', height: '100%', maxWidth: '450px', border: 'none', overflow: 'hidden', margin: '0 auto' }} src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(video.original_url)}&show_text=false`} scrolling="no" allowFullScreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                  )}
                </>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                   <div style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                     <span style={{ fontSize: '24px', color: '#fff', marginLeft: '5px' }}>▶</span>
                   </div>
                </div>
              )}

              {/* Floating Action Buttons */}
              <div style={{ position: 'absolute', right: '15px', bottom: '100px', display: 'flex', flexDirection: 'column', gap: '20px', zIndex: 10 }}>
                <button style={{ backgroundColor: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', color: '#fff', backdropFilter: 'blur(5px)', cursor: 'pointer' }}>❤️</button>
                <button onClick={() => navigator.clipboard.writeText(video.original_url).then(() => alert('Link Copied!'))} style={{ backgroundColor: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', color: '#fff', backdropFilter: 'blur(5px)', cursor: 'pointer' }}>🔗</button>
              </div>
              
            </div>
          ))
        ) : (
          <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold' }}>No videos available.</div>
        )}
      </div>
    </div>
  );
}

export default MobileExplore;